import React, { Fragment, useEffect, useState } from 'react';
import ExpenseInfo from './ExpenseInfo';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import '../css/table-styles.css'

const ExpenseList = ({ is_admin }) => {

    const [expenses, setExpenses] = useState([]);
    const [display_expenses, setDisplay_expenses] = useState([]);

    const [filter_id, setFilter_id] = useState("")
    const [filter_cost, setFilter_cost] = useState("")
    const [filter_proof, setFilter_proof] = useState(false)


    const getExpenses = async () => {
        try {
            const response = await fetch("/expenses/all", {
                method: "GET",
                headers: { token: localStorage.token }
            });
            const jsonDataReq = await response.json();

            jsonDataReq.rows.map(expense => {
                expense.description_display = expense.expense_description.substring(0, 10);
                if (expense.expense_description.length > 10) {
                    expense.description_display += '...'
                }
                if (expense.submitted_proof === true) {
                    expense.submitted_proof_display = "Yes"
                } else {
                    expense.submitted_proof_display = "No"
                }
                expense.cost_display = '$' + parseInt(expense.cost_cents) / 100
            })
            setExpenses(jsonDataReq.rows);
            setDisplay_expenses(jsonDataReq.rows);
        } catch (err) {
            console.error("Failed: getting all expenses");
            console.error(err.message);
        }
    }

    function filter() {
        try {
            setDisplay_expenses(expenses.filter(expense => {
                var pass = true;
                if (filter_id !== "") {
                    if (!expense.expense_id.toLowerCase().includes(filter_id.toLocaleLowerCase()) && !expense.shift_id.toLowerCase().includes(filter_id.toLocaleLowerCase()))
                        pass = false;
                }
                if (filter_cost !== "") {
                    if ((parseInt(expense.cost_cents) / 100) < filter_cost)
                        pass = false;
                }
                if (filter_proof) {
                    if (!expense.submitted_proof) {
                        pass = false
                    }
                }
                return pass;
            }))
        } catch (err) {
            console.error("Failed: filtering expenses");
            console.error(err.message);
        }
    }

    const download_expense = async (expense_id, btn) => {
        try {
            const response = await fetch("/expenses/proof", {
                method: "GET",
                headers: { token: localStorage.token, expense_id: expense_id }
            })

            if (response.status === 401 || response.status === 403 || response.status === 404 || response.status === 409) {
                document.getElementById(btn).className = "btn btn-danger"
                document.getElementById(btn).innerText = "empty"
                throw 'doesn\'t exist, updating database accordingly';
            }
            var data = await response.json();

            var a = document.createElement("a"); //Create <a>
            a.href = data; //Image Base64 Goes here
            a.download = "Proof_for:_"+ expense_id + ".jpg"; //File name Here
            a.click(); //Downloaded file

        } catch (err) {
            console.error("Failed: getting expense proof for " + expense_id);
            console.error(err.message || err);
        }
    }

    useEffect(() => {
        getExpenses();
    }, [])

    useEffect(() => {
        filter();
    }, [filter_id, filter_cost, filter_proof])
    return (
        <div className="container">
            <Fragment>
                <h1 className="mt-5">Expense List</h1>
                <h5 className="ml-2">Filters:</h5>
                <input className="form-control m-1" type="text" placeholder="ID" value={filter_id} onChange={e => setFilter_id(e.target.value)} />
                <input className="form-control m-1" type="text" placeholder="Cost" value={filter_cost} onChange={e => setFilter_cost(e.target.value)} />


                <input placeholder="Proof" type="checkbox" className="form-check-input ml-2 mt-2" id="proof_filter_check" value={filter_proof} onChange={e => setFilter_proof(e.target.checked)} />
                <label className="form-check-label ml-5 mt-1" htmlFor="proof_filter_check">
                    Has proof
                </label>

                <Table className="table mt-5 text-center">
                    <Thead>
                        <Tr>
                            <Th>Internal Expense ID</Th>
                            <Th>Owning Shift</Th>
                            <Th>Cost</Th>
                            <Th>Description</Th>
                            <Th>Proof?</Th>
                            {is_admin >= 1 && <Th>Expand</Th>}
                            {/* {is_admin ==== 2 && <Th>Edit</Th>} */}
                            {/* {is_admin ==== 2 && <Th>Make Inactive</Th>} */}

                        </Tr>
                    </Thead>
                    <Tbody>
                        {/* <Tr>
                        <Td>John</Td>
                        <Td>Doe</Td>
                        <Td>john@example.com</Td>
                    </Tr> */}
                        {display_expenses.map(expense => (
                            <Tr key={expense.expense_id}>
                                <Td>{expense.expense_id}</Td>
                                <Td>{expense.shift_id}</Td>
                                <Td>{expense.cost_display}</Td>
                                <Td>{expense.description_display}</Td>
                                {expense.submitted_proof ? <Td><button id={"expense_id" + expense.expense_id} className="btn btn-info" onClick={() => download_expense(expense.expense_id, "expense_id" + expense.expense_id)} >{"View"}</button></Td> : <Td>N/A</Td>}
                                {is_admin >= 1 && <Td><ExpenseInfo expense={expense} /></Td>}
                                {/* {is_admin ==== 2 && <Td><button className="btn btn-info">Edit</button></Td>} */}
                                {/* {is_admin ==== 2 && <Td><button className="btn btn-danger">Make Inactive</button></Td>} */}
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Fragment>
        </div >
    );
}

export default ExpenseList;

